import { COPY } from './copy';

/**
 * Where the Assignment card would be, for a user who cannot use server-side (PER-178) looking
 * at an experiment staff made server-decided. Without it the card and the page targeting both
 * vanish and nothing says why.
 */
export const AssignedByServerNote = () => (
  <section className="bg-panel border-line rounded-panel border px-4 py-3">
    <h2 className="micro-label text-foreground">{COPY.title}</h2>
    <p className="supporting mt-1">{COPY.assignedByServer}</p>
  </section>
);
